export enum Tiers {
    Tier1 = 'Tier1',
    Tier2 = 'Tier2',
    Tier3 = 'Tier3'
}
